/* eslint-disable max-len */
import api from '../../../services/api';

const API_URL = '/api/v1/admin/dataSetManager';

/**
 * @returns {Promise<ApiAdmin.GetAllDataSetsResponse>}
 */
export const getAllDataSets = () => api.get(API_URL);

/**
 * @returns {Promise<ApiAdmin.GetAvailableFieldsResponse>}
 */
export const getAvailableFields = () => api.get(`${API_URL}/availableFields`);

/**
 * @param {Object} dataSetInformation
 * @param {string} dataSetInformation.name
 * @param {string} dataSetInformation.description
 * @param {string[]} dataSetInformation.fieldsSelected
 * @returns {Promise<ApiAdmin.CreateDataSetResponse>}
 */
export const createDataSet = (dataSetInformation) => api.post(API_URL, {
    Name: dataSetInformation.name,
    Description: dataSetInformation.description,
    FieldsSelected: dataSetInformation.fieldsSelected
});

/**
 * @param {string} dataSetId
 * @param {Object} dataSetInformation
 * @param {string} dataSetInformation.name
 * @param {string} dataSetInformation.description
 * @param {string[]} dataSetInformation.fieldsSelected
 * @returns {Promise<ApiAdmin.UpdateDataSetResponse>}
 */
export const updateDataSet = (dataSetId, dataSetInformation) => api.put(`${API_URL}/${dataSetId}`, {
    Name: dataSetInformation.name,
    Description: dataSetInformation.description,
    FieldsSelected: dataSetInformation.fieldsSelected
});

/**
 * @param {string} sourceDataSetId
 * @param {Object} dataSetInformation
 * @param {string} dataSetInformation.name
 * @param {string} dataSetInformation.description
 * @param {string[]} dataSetInformation.fieldsSelected
 * @returns {Promise<ApiAdmin.DuplicateDataSetResponse>}
 */
export const duplicateDataSet = (sourceDataSetId, dataSetInformation) => api.post(`${API_URL}/${sourceDataSetId}/duplicate`, {
    NewName: dataSetInformation.name,
    NewDescription: dataSetInformation.description,
    NewFieldsSelected: dataSetInformation.fieldsSelected
});

/**
 * @param {string} dataSetId
 * @returns {Promise<import('axios').AxiosResponse<any>>}
 */
export const deleteDataSet = (dataSetId) => api.delete(`${API_URL}/${dataSetId}`);

